import { Formik, Form } from "formik";
import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import * as Yup from "yup";
import { GeneralTextAreaField } from "../Custom-Forms/General-Text-Area-Field";
import { axiosInstance } from "../../utils/axios-instance";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { ResetPasswordSubmission } from "./Reset-Password-Submission";
import {toast} from 'react-toastify';

import { selectSignIn } from "../../store/slices/signed-in-slice";

export const ResetPassword = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isSignedIn = useSelector(selectSignIn);
    const [submitted, setSubmitted] = useState(false);
    const ToastID = React.useRef(null)
    // Make sure an email is provided before
    const resetPasswordValidationSchema = Yup.object({
        email: Yup.string().email("Invalid Email address").required("Required")
    });

    // If user is signed in,
    // redirect to the home page
    useEffect(() => {
        if (isSignedIn) {
            navigate("/");
        }
    }, [dispatch, isSignedIn, navigate]);
    return (
        <>
            <>
                <Container className="bg-body-secondary rounded-3 justify-content-center my-4 py-4">
                    <h1>Reset Password</h1>

                    <Row className=" card-font mx-0 mb-0">
                        <Formik
                            initialValues={{
                                email: ""
                            }}
                            validationSchema={resetPasswordValidationSchema}
                            onSubmit={async (values, { setStatus }) => {
                                ToastID.current = toast.loading(`Attempting to Send Reset Password Link`, {theme: "colored", containerId:"root", autoClose: "5000"} )
                                try {
                                    const response = await axiosInstance({
                                        method: "post",
                                        url: "/request-reset-password",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        data: {
                                            email: values.email
                                        }
                                    });

                                    toast.update(ToastID.current , {render: `Successfully Send Reset Password Link. Please Check Your Email`, type: "success", isLoading: false, theme: "colored", autoClose: "3500",  containerId:"root"} )
                                    setStatus({ error: false });
                                    setSubmitted(true);
                                    // setTimeout(() => {
                                    //     navigate('/signin');
                                    // }, 2500);
                                } catch (error) {
                                    // toast.update(ToastID.current , {render: `Failed to Send Reset Password Link. Please Try Again.`, type: "error", isLoading: false, theme: "colored", autoClose: "5000", containerId:"root"})
                                    toast.update(ToastID.current , {render: `Successfully Send Reset Password Link. Please Check Your Email`, type: "success", isLoading: false, theme: "colored", autoClose: "3500",  containerId:"root"} )
                                    setStatus({ error: false });
                                    // setTimeout(() => {
                                    //     navigate('/signin');
                                    // }, 2500);
                                    return Promise.reject(error);
                                }
                            }}
                        >
                            <Form>
                                {!submitted && (
                                    <>
                                        <Row className="mb-2">
                                            <GeneralTextAreaField
                                                label="Email Address:"
                                                className="form-control"
                                                component="input"
                                                name="email"
                                                rows="1"
                                                placeholder="Enter Email Address"
                                                autoComplete="email"
                                            />
                                            {/* <GeneralTextInput
                                                    label="Email Address"
                                                    name="email"
                                                    type="text"
                                                    placeholder="Email Address"
                                                /> */}
                                        </Row>
                                    </>
                                )}
                                <ResetPasswordSubmission
                                    isSubmitted={submitted}
                                />
                            </Form>
                        </Formik>
                    </Row>
                </Container>
            </>
        </>
    );
};
